<tgrid-layer-header [layer]="this" [additionIcons]="iconConfig()">
  <div ngProjectAs="filters">
    <form [formGroup]="filterGroup">
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Affordability Metric</mat-label>
        <mat-select formControlName="metric">
          @for (m of metrics; track m.key) {
            <mat-option [value]="m.key">{{ m.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
  </div>

  <div class="legend">
    @for (item of legendElements; track $index) {
      <div class="legend-label">
        <div class="color-box" [style.background-color]="item.color"></div>
        <span>{{ item.label }}</span>
      </div>
    }
    <div class="legend-label">
      <div class="color-box" [style.background-color]="'#444444'"></div>
      <span>Not Available</span>
    </div>
  </div>
</tgrid-layer-header>

